import React from "react";
import { IoIosArrowForward, IoMdAddCircleOutline } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import { setElement } from "../../Redux/SidebarReducer";
import { Link, useLocation } from "react-router-dom";
import { MdOutlineList } from "react-icons/md";
import { VscWorkspaceTrusted } from "react-icons/vsc";
import {
  FiType,
  FiFileText as PanelsLogIcon, // Feather
} from "react-icons/fi";
const PanelsElementSidbarDropDown = (props) => {
  const { title, show, icon: IconComponent } = props;
  const location = useLocation();

  // Check if the current path matches the dropdown's route
  const isActive = location.pathname === `/${show.replace(/\s+/g, "-")}`;
  const isAddActive = location.pathname === `/${show}/Add`;
  const isTrustedActive = location.pathname === `/${show}/Trusted`;
  const isLogs = location.pathname === `/${show}/Log`;
  const isUpdatedPanels = location.pathname === `/${show}/UpdatedPanels`;
  const PanelsByType = location.pathname === `/${show}/PanelsByType`;
  const elementActive = useSelector((state) => state.Sidebar.elementActive);
  const dispatch = useDispatch();
  const handleClick = () => {
    const value = title === elementActive ? "" : title;
    dispatch(setElement(value));
  };

  return (
    <li className=" ">
      <span
        onClick={handleClick}
        className="pr-0 py-[12px]  pl-[25px]  flex hover:text-primary duration-300 relative  items-center cursor-pointer"
      >
        {IconComponent && <IconComponent className={"mr-[20px]"} />}
        {show}
        <IoIosArrowForward
          className={`absolute right-3 duration-300 text-[14px]
        ${elementActive === title ? "rotate-90" : "rotate-0"}    `}
        />
      </span>
      <ul
        className={`text-[15px]  pl-[19px] duration-300 overflow-hidden  ${
          elementActive === title ? "h-[15.8rem]" : "h-0"
        } `}
      >
        <Link to={`/${show}/Add`} color="inherit" underline="none">
          <li
            className={`${
              isAddActive
                ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                : "hover:text-primary"
            } pr-0 py-[8px]  pl-[25px] text-center whitespace-nowrap  flex justify-start gap-x-3 items-center`}
          >
            <IoMdAddCircleOutline />
            <span className=" duration-100 flex  items-center">
              Add {title}
            </span>
          </li>
        </Link>
        <Link
          to={`/${show.replace(/\s+/g, "-")}`}
          color="inherit"
          underline="none"
        >
          <li
            className={`${
              isActive
                ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                : "hover:text-primary"
            } pr-0 py-[8px]  pl-[25px] text-center flex justify-start whitespace-nowrap gap-x-3 items-center`}
          >
            <MdOutlineList />
            <span className=" duration-100 flex  items-center">
              {show} List
            </span>
          </li>
        </Link>
        <Link
          to={`/${show.replace(/\s+/g, "-")}/Trusted`}
          color="inherit"
          underline="none"
        >
          <li
            className={`${
              isTrustedActive
                ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                : "hover:text-primary"
            } pr-0 py-[8px]  pl-[25px] text-center flex justify-start whitespace-nowrap gap-x-3 items-center`}
          >
            <VscWorkspaceTrusted />
            <span className=" duration-100 flex  items-center">
              Trusted {show}
            </span>
          </li>
        </Link>
        <Link
          to={`/${show.replace(/\s+/g, "-")}/Log`}
          color="inherit"
          underline="none"
        >
          <li
            className={`${
              isLogs
                ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                : "hover:text-primary"
            } pr-0 py-[8px]  pl-[25px] text-center flex justify-start whitespace-nowrap gap-x-3 items-center`}
          >
            <PanelsLogIcon />
            <span className=" duration-100 flex  items-center">
              {show} Logs
            </span>
          </li>
        </Link>
        <Link
          to={`/${show.replace(/\s+/g, "-")}/UpdatedPanels`}
          color="inherit"
          underline="none"
        >
          <li
            className={`${
              isUpdatedPanels
                ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                : "hover:text-primary"
            } pr-0 py-[8px]  pl-[25px] text-center flex justify-start whitespace-nowrap gap-x-3 items-center`}
          >
            <PanelsLogIcon />
            <span className=" duration-100 flex  items-center">
              UpadetedPanels
            </span>
          </li>
        </Link>
        <Link
          to={`/${show.replace(/\s+/g, "-")}/PanelsByType`}
          color="inherit"
          underline="none"
        >
          <li
            className={`${
              PanelsByType
                ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                : "hover:text-primary"
            } pr-0 py-[8px]  pl-[25px] text-center flex justify-start whitespace-nowrap gap-x-3 items-center`}
          >
            <FiType />
            <span className=" duration-100 flex  items-center">
              PanelsByType
            </span>
          </li>
        </Link>
      </ul>
    </li>
  );
};

export default PanelsElementSidbarDropDown;
